import React from 'react';
import { MessageCircle } from 'lucide-react';

const ChatWidget = () => {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="fixed bottom-6 right-6 z-40">
      {open && (
        <div className="mb-3 w-72 bg-white shadow-2xl border border-gray-200 rounded overflow-hidden fade-up">
          <div className="bg-[#0d274d] text-white px-4 py-3 flex items-center justify-between">
            <span className="font-semibold text-sm">Cisco Assistant</span>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white text-sm">✕</button>
          </div>
          <div className="p-4 text-sm text-gray-700">Hello, how can I help?</div>
          <div className="px-4 pb-4">
            <input type="text" placeholder="Type a message..." className="w-full border border-gray-300 focus:border-[#00bceb] outline-none rounded px-3 py-2 text-sm" />
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        className="bg-[#00bceb] hover:bg-[#0099c2] text-white rounded-full p-4 shadow-xl transition-colors"
        aria-label="Open chat"
      >
        <MessageCircle className="w-5 h-5" />
      </button>
    </div>
  );
};

export default ChatWidget;
